import { render, staticRenderFns } from "./InfoMy.vue?vue&type=template&id=60d75760"
import script from "./InfoMy.vue?vue&type=script&lang=js"
export * from "./InfoMy.vue?vue&type=script&lang=js"
import style0 from "./InfoMy.vue?vue&type=style&index=0&id=60d75760&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports